var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.849121,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#1C1C1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.8403C18.5 9.25233 15.588 6.34033 12 6.34033C8.412 6.34033 5.5 9.25233 5.5 12.8403C5.5 15.9863 7.736 18.6058 10.7 19.2103V14.7903H9.4V12.8403H10.7V11.2153C10.7 9.96083 11.7205 8.94033 12.975 8.94033H14.6V10.8903H13.3C12.9425 10.8903 12.65 11.1828 12.65 11.5403V12.8403H14.6V14.7903H12.65V19.3078C15.9325 18.9828 18.5 16.2138 18.5 12.8403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/f.ea0bc251d6b2310809e7fbcead4dd876.svg";
export { ForwardRef as ReactComponent };